import { Component, Input } from '@angular/core';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-tag',
  standalone: true,
  templateUrl: './tag.component.html',
  imports: [
    NzTagComponent
  ],
  styleUrls: ['./tag.component.css']
})
export class TagComponent {
  @Input() text: string = '';     // El texto de la etiqueta
  @Input() color: string = 'default';  // El color de la etiqueta, por defecto 'default'

  constructor() { }
}
